import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { Apartamento } from 'src/app/shared/model/apartamento.model';
import { Segmentacao } from 'src/app/shared/model/segmentacao.model';
import { DataService } from 'src/app/shared/service/data.service';

@Component({
  selector: 'dom436-segments',
  templateUrl: './segments.component.html'
})
export class SegmentsComponent implements OnInit {
  
  modalRef: BsModalRef;
  selectedApartamento: Apartamento = null;
  segmentacoes: Segmentacao[];

  carouselOptions: OwlOptions = {
    items: 1,
    loop: false,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    navSpeed: 700,
    nav: true,
    navText:["<div class='nav-btn prev-slide'><img alt='Seta' src='assets/images/arrow-left-black.png' /></div>","<div class='nav-btn next-slide'><img alt='Seta' src='assets/images/arrow-right-black.png' /></div>"],
    autoplay: false,
    responsive: {
      0: {
        items: 1 
      }
    },
  }

  constructor(
    private dataService: DataService,
    private modalService: BsModalService,
    private router: Router,
  ) { 
    this.selectedApartamento = JSON.parse(sessionStorage.getItem('selectedApartamento'));
    if(!this.selectedApartamento) {
      this.router.navigate(['/selecionar-apartamento']);
    }
  }

  getNome(nomeCompleto, tipo) {
    let nomeArray = nomeCompleto.split('_');
    if(tipo === 'normal') {
      return nomeArray[0];
    } else if(tipo === 'hover') {
      return nomeArray[1];
    }
  }

  @ViewChild('configuratorAlertModal', { static: true }) configuratorAlertModal: TemplateRef<any>;
  ngOnInit(): void {
    this.dataService.listSegmentacoes()
      .subscribe(segmentacoes => {
        this.segmentacoes = segmentacoes;
      });
    this.openModal(this.configuratorAlertModal);
  }
  
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template
    );
  }

}
